/** TBS statuses as the TBS Tracker screens list and filter them (a draft has no TBS number yet, so it is never listed). */
export const TBS_STATUS_OPTIONS: { label: string; value: string }[] = [
    { label: "In Transit", value: "in-transit" },
    { label: "Received", value: "received" },
    { label: "Semi Issued", value: "semi-issued" },
    { label: "Issued", value: "issued" },
    { label: "Returned", value: "returned" },
];

export const getTbsStatusLabel = (status: string): string =>
    TBS_STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status ?? "-";

/** same colours as the Status column of the TBS Store screen */
export const getTbsStatusClassName = (status: string): string => {
    switch (status) {
        case "issued":
            return "text-success";
        case "semi-issued":
            return "text-warning";
        case "received":
            return "text-danger";
        case "returned":
            return "text-secondary";
        default:
            return "text-primary";
    }
};
